import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { BillingOverviewTab } from "./BillingOverviewTab";
import { BillingInvoicesTab } from "./BillingInvoicesTab";
import { BillingPaymentsTab } from "./BillingPaymentsTab";
import { BillingCustomersTab } from "./BillingCustomersTab";
import { BillingReportingTab } from "./BillingReportingTab";

const TAB_DEFS = [
  { id: "overview", label: "Overview" },
  { id: "invoices", label: "Invoices" },
  { id: "payments", label: "Payments" },
  { id: "customers", label: "Customers" },
  { id: "reporting", label: "Reporting" },
];

export const BillingWorkspace = ({ accessLevel }) => {
  const { API } = useAuth();
  const [tab, setTab] = useState("overview");
  const canManage = accessLevel === "manage";
  const [focusInvoiceId, setFocusInvoiceId] = useState(null);
  const [autoOpenCreate, setAutoOpenCreate] = useState(false);

  const goToInvoices = (invoiceId) => { setFocusInvoiceId(invoiceId || null); setTab("invoices"); };
  const createInvoice = () => { setAutoOpenCreate(true); setTab("invoices"); };

  return (
    <div data-testid="billing-workspace">
      <div className="flex flex-wrap items-center gap-1 border-b border-slate-200 dark:border-white/10" data-testid="billing-tabs">
        {TAB_DEFS.map((t) => (
          <button
            key={t.id}
            type="button"
            onClick={() => setTab(t.id)}
            data-testid={`billing-tab-${t.id}`}
            className={`border-b-2 px-4 py-2.5 text-sm font-bold transition-colors duration-150 ${tab === t.id ? "border-[#0052FF] text-[#0052FF]" : "border-transparent text-slate-500 hover:text-slate-900 dark:text-slate-400 dark:hover:text-white"}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-5">
        {tab === "overview" && <BillingOverviewTab API={API} canManage={canManage} onViewInvoices={goToInvoices} onViewPayments={() => setTab("payments")} onCreateInvoice={createInvoice} onViewCustomers={() => setTab("customers")} />}
        {tab === "invoices" && <BillingInvoicesTab API={API} canManage={canManage} focusInvoiceId={focusInvoiceId} clearFocus={() => setFocusInvoiceId(null)} autoOpenCreate={autoOpenCreate} clearAutoOpenCreate={() => setAutoOpenCreate(false)} />}
        {tab === "payments" && <BillingPaymentsTab API={API} canManage={canManage} />}
        {tab === "customers" && <BillingCustomersTab API={API} canManage={canManage} />}
        {tab === "reporting" && <BillingReportingTab />}
      </div>
    </div>
  );
};
